module.exports = __webpack_public_path__ + "img/rongYu9.260358a4.png";